import { render, staticRenderFns } from "./sales-statistics-page.vue?vue&type=template&id=35d088d9&"
import script from "./sales-statistics-page.js?vue&type=script&lang=js&"
export * from "./sales-statistics-page.js?vue&type=script&lang=js&"
import style0 from "./sales-statistics-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
